/* eslint-disable */
import Axios from "axios";
import Message from "element-ui/lib/message";
import {
  buildOauthRedirectUrl,
  clearAllAuthTokens,
  getAuthSessionVersion,
  getMainToken,
  getMicroToken,
  isMicroTokenRequest,
  replaceRequestAuthToken,
  syncMainTokenFromResponse,
} from "../utils/authSession";

function attachMainToken(config) {
  config.__authSessionVersion = getAuthSessionVersion();
  const token = getMainToken();
  if (!config.headers) {
    config.headers = {};
  }
  if (token && !(config.headers && config.headers.Authorization)) {
    config.headers.Authorization = token;
  }
  return config;
}

async function retryWithFreshMicroToken(request, error) {
  const originalRequest = error.config || {};
  if (originalRequest.__isMicroTokenRetry) {
    throw error;
  }
  if (typeof window.refreshToken !== "function") {
    throw error;
  }

  originalRequest.__isMicroTokenRetry = true;
  await window.refreshToken();
  const nextToken = getMicroToken();
  if (!nextToken) {
    throw error;
  }

  replaceRequestAuthToken(originalRequest, nextToken);
  return request(originalRequest);
}

function redirectToOauth(error) {
  const response = error.response || {};
  const data = response.data || {};
  const payload = data.data || {};
  const errMsg = data.msg || "登录已失效，请重新登录";

  Message.error(errMsg);
  clearAllAuthTokens();
  window.location.href = buildOauthRedirectUrl(payload);
}

export function createRequestClient() {
  const request = Axios.create({
    timeout: 200000,
  });

  request.interceptors.request.use(
    config => attachMainToken(config),
    error => Promise.reject(error),
  );

  request.interceptors.response.use(
    response => {
      if (response.status === 208) {
        syncMainTokenFromResponse(response);
      }
      return response.data;
    },
    async error => {
      const response = error.response || {};
      const status = response.status;

      if (status === 401) {
        if (error.config && error.config.__authSessionVersion !== getAuthSessionVersion()) {
          return Promise.reject(error);
        }
        if (isMicroTokenRequest(error.config)) {
          try {
            return await retryWithFreshMicroToken(request, error);
          } catch (refreshError) {
            return Promise.reject(refreshError);
          }
        }

        redirectToOauth(error);
        return Promise.reject(error);
      }

      if (status === 403) {
        Message.error("暂无权限访问，请联系管理员！");
      } else if (status === 500) {
        Message.error("服务器内部错误，请稍后重试！");
      } else {
        const data = response.data || {};
        Message.error(`请求失败：${data.msg || `状态码${status || ""}`}`);
      }

      return Promise.reject(error);
    },
  );

  return request;
}

